module.exports = __webpack_public_path__ + "static/ethan-9a582b744999cc7177e30a2a5bfe5337.jpg";